'use strict';

var _extends = require('../../../node_modules/@babel/runtime/helpers/extends.js');
var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var classNames = require('classnames');
require('prop-types');
var _Error = require('../../../node_modules/@material-ui/icons/Error.js');
var Button = require('../../Inputs/Buttons/Button/Button.js');
var withStyles = require('../../Styles/withStyles.js');
var Snackbar$2 = require('../../../node_modules/@material-ui/core/esm/Snackbar/Snackbar.js');
var SnackbarContent = require('../../../node_modules/@material-ui/core/esm/SnackbarContent/SnackbarContent.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var styles = function styles(theme) {
  return {
    root: {},
    error: {
      backgroundColor: theme.palette.error.main
    },
    button: {
      color: theme.palette.common.white
    },
    icon: {
      opacity: 0.9,
      marginRight: theme.spacing(1)
    },
    message: {
      display: 'flex',
      alignItems: 'center'
    }
  };
};

var Snackbar = function Snackbar(_ref) {
  var classes = _ref.classes,
      message = _ref.message,
      actionMessage = _ref.actionMessage,
      onClick = _ref.onClick,
      variant = _ref.variant,
      buttonProps = _ref.buttonProps,
      restOfProps = objectWithoutProperties(_ref, ["classes", "message", "actionMessage", "onClick", "variant", "buttonProps"]);

  var _ref2 = buttonProps || {},
      _ref2$classes = _ref2.classes,
      buttonPropsClasses = _ref2$classes === void 0 ? {} : _ref2$classes;

  buttonPropsClasses = _objectSpread({}, buttonPropsClasses, {
    root: classNames__default["default"](classes.button, buttonPropsClasses.root)
  });
  return React__default["default"].createElement(Snackbar$2["default"], _extends["default"]({
    ContentProps: {
      classes: {
        root: classNames__default["default"](defineProperty({}, classes.error, variant === 'error'))
      },
      contentComponent: SnackbarContent["default"],
      message: React__default["default"].createElement("span", {
        className: classes.message
      }, variant === 'error' && React__default["default"].createElement(_Error, {
        className: classNames__default["default"](classes.icon)
      }), message),
      action: actionMessage && React__default["default"].createElement(Button, _extends["default"]({
        onClick: onClick
      }, buttonProps, {
        classes: buttonPropsClasses
      }), actionMessage)
    }
  }, restOfProps));
};

Snackbar.defaultProps = {
  message: '',
  onClick: function onClick() {},
  variant: '',
  actionMessage: '',
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left'
  },
  autoHideDuration: 6000,
  open: false
};
var Snackbar$1 = withStyles["default"](styles)(Snackbar);

module.exports = Snackbar$1;
